import { jsx as _jsx } from "react/jsx-runtime";
import MyLightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import './LightBox.scss';
export const LightBox = ({ open, onClose, url }) => {
    return (_jsx(MyLightbox, { open: open, close: onClose, slides: [{ src: url }], controller: { closeOnBackdropClick: true } }));
};
